var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.295 6.291h-.349V4.664a3.72 3.72 0 0 0-7.44 0V6.29h-.349a.698.698 0 0 0-.698.698v7.208a.698.698 0 0 0 .698.698h8.138a.698.698 0 0 0 .698-.698V6.989a.698.698 0 0 0-.698-.698Zm-6.86-1.627a2.79 2.79 0 1 1 5.581 0V6.29h-5.58V4.664Zm6.628 9.3H1.39V7.221h7.673v6.743Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.807 10.012H4.645v1.162h1.162v-1.162Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lock.06eadbf5862848bb7a4d0cfc8ec530ec.svg";